import { Auth } from 'aws-amplify';
import { useEffect, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

const useAuthSession = () => {
  const dispatch = useDispatch();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  const checkForAuth = useCallback(async () => {
    try {
      const data = await Auth.currentSession();
      dispatch({ type: 'accounts/setCustomerId', payload: data.getIdToken().payload.customerId });
    } catch (err) {
      dispatch({ type: 'accounts/setCustomerId', payload: null });
    }
    setIsAuthChecked(true);
  }, [dispatch]);

  useEffect(() => {
    if (!isAuthChecked) {
      checkForAuth();
    }
  }, [checkForAuth, isAuthChecked]);

  return { isAuthChecked };
};

export default useAuthSession;
